import { DatePipe } from '@angular/common'
import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core'
import {
  NgbCalendar,
  NgbDate,
  NgbDateParserFormatter,
} from '@ng-bootstrap/ng-bootstrap'
import {
  DropdownDirection,
  DropdownMenuData,
  DropdownSize,
  DropdownState,
  DropdownVariant,
} from '@vg-constellation/angular-18/dropdown'
import { Subscription } from 'rxjs'
import { AEMChunk } from 'src/app/services/AEM/aem-chunk.model'
import { CentralContentService } from 'src/app/services/content/central-content.service'

import { DistributionsService } from './distributions.service'

@Component({
  selector: 'distributions',
  templateUrl: './distributions.component.html',
  styleUrls: ['./distributions.component.scss'],
  providers: [],
})
export class DistributionsComponent implements OnInit, OnDestroy {
  @ViewChild('payableDialogContent', { static: false })
  public payableDialogContent: TemplateRef<any>
  @ViewChild('recordDialogContent', { static: false })
  public recordDialogContent: TemplateRef<any>
  @ViewChild('dividendDialogContent', { static: false })
  public dividendDialogContent: TemplateRef<any>
  @ViewChild('distributionYieldContent', { static: false })
  public distributionYieldContent: TemplateRef<any>
  @ViewChild('realiazeDialogContent', { static: false })
  public realiazeDialogContent: TemplateRef<any>
  @ViewChild('distributionAriaLiveRegion', { static: false })
  public distributionAriaLiveRegion: ElementRef

  dropdownSize: DropdownSize = 'medium'
  direction: DropdownDirection = 'below'
  activeItems: string | string[] = []
  selectedText: string
  placeholderText: string
  variant: DropdownVariant = 'basic'
  hintText: string
  hideLabel: boolean = true
  menuData: DropdownMenuData

  readonly maxPageSize: number = 10
  distributionsSubscription: Subscription
  distributionsModel: any
  realizedPerofNAV: number
  unrealizedPerofNAV: number
  items: Array<string>
  currentItems: Array<string>
  pageSize: number
  page: number
  hoveredDate: NgbDate | null = null
  fromDate: NgbDate | null
  toDate: NgbDate | null
  maxFromDate: NgbDate | null
  maxToDate: NgbDate | null
  fromDateFilter: string
  toDateFilter: string
  readonly maxYears: number = 10
  pageNumberList = []
  slectedPage: number
  readonly timeConvertUTC: number = 4
  showDistributionYield: boolean
  noDistributionTableData = false
  hideDistributionYeild: boolean

  //AEM content variables
  fundsCapitalBanner: AEMChunk
  fundsCapitalBanner2: AEMChunk
  realizedUnrealizedGains: AEMChunk
  realizedGainsAndLosses: AEMChunk
  unRealizedGainsAndLosses: AEMChunk
  payableDateDefinition: AEMChunk
  recordDateDefinition: AEMChunk
  exDividendDateDefinition: AEMChunk
  reInvestDateDefinition: AEMChunk
  distributionYieldDefinition: AEMChunk
  aemContentSub: Subscription

  public datePipe: DatePipe

  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  scrollBarPosition = 0
  showRightButton = true
  tableContainer: HTMLElement
  innerWidth: number
  dialogTitle: string
  dialogBody: string
  showRealizeDialogContent: boolean = true

  /* eslint max-params: [2, 5] */
  // eslint-disable-next-line max-params
  constructor(
    private readonly viewContainer: ViewContainerRef,
    private readonly distributionsService: DistributionsService,
    private readonly calendar: NgbCalendar,
    private readonly centralContentService: CentralContentService,
    public formatter: NgbDateParserFormatter,
  ) {
    this.datePipe = new DatePipe('en-US')
    this.fromDate = calendar.getPrev(calendar.getToday(), 'y', this.maxYears)
    this.toDate = calendar.getToday()
    this.maxFromDate = calendar.getPrev(calendar.getToday(), 'y', this.maxYears)
    this.maxToDate = calendar.getToday()
  }

  public setDialogInfo(title = '') {
    this.dialogTitle = title
    if (this.dialogTitle === 'Distribution yield') {
      this.dialogBody = this.distributionYieldDefinition?.contentValue
      this.showRealizeDialogContent = false
    }
    if (this.dialogTitle === 'Reinvest date') {
      this.dialogBody = this.reInvestDateDefinition?.contentValue
      this.showRealizeDialogContent = false
    }
    if (this.dialogTitle === 'Ex-dividend date') {
      this.dialogBody = this.exDividendDateDefinition?.contentValue
      this.showRealizeDialogContent = false
    }
    if (this.dialogTitle === 'Record date') {
      this.dialogBody = this.recordDateDefinition?.contentValue
      this.showRealizeDialogContent = false
    }
    if (this.dialogTitle === 'Payable date') {
      this.dialogBody = this.payableDateDefinition?.contentValue
      this.showRealizeDialogContent = false
    }
    if (
      this.dialogTitle === 'More about realized & unrealized gains & losses'
    ) {
      this.showRealizeDialogContent = true
    }
  }

  ngOnInit() {
    this.findScreenSize()
    this.pageSize = this.maxPageSize
    this.page = 1

    this.distributionsSubscription = this.distributionsService
      .getModelData()
      .subscribe((model) => {
        this.distributionsModel = model
        // init the NAV percentage
        /* istanbul ignore next */
        this.realizedPerofNAV = parseFloat(
          this.distributionsModel?.distributions.realizedUnrealizedGain
            ?.realizedPctNAV
            ? this.distributionsModel.distributions.realizedUnrealizedGain
                .realizedPctNAV
            : '0',
        )
        /* istanbul ignore next */
        this.unrealizedPerofNAV = parseFloat(
          this.distributionsModel?.distributions.realizedUnrealizedGain
            ?.unRealizedPctNAV
            ? this.distributionsModel.distributions.realizedUnrealizedGain
                .unRealizedPctNAV
            : '0',
        )

        this.hideDistributionYeild = this.isDistributionYieldCompletelyRemoved(
          this.distributionsModel.distributions,
        )
        /* istanbul ignore next */
        this.showDistributionYield = !(
          this.distributionsModel?.profile?.fundProfile?.fundFact?.isBalanced ||
          this.distributionsModel?.profile?.fundProfile?.fundFact?.isStock ||
          this.distributionsModel?.profile?.fundProfile?.fundFact
            ?.isInternational ||
          this.distributionsModel?.profile?.fundProfile?.fundFact
            ?.isSectorSpecific
        )
        this.addItem()
        this.currentItems = this.items
        this.setPageNumber()
        this.calltableScrollEvent()
      })
    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.parseAEMContent(content)
      },
    )
  }

  isDistributionYieldCompletelyRemoved(data: any): boolean {
    if (!data?.divCapGain?.item || !Array.isArray(data.divCapGain.item)) {
      return false // Invalid structure
    }

    return data.divCapGain.item.every(
      (entry: any) => !('disributionYield' in entry),
    )
  }

  parseAEMContent(content) {
    this.fundsCapitalBanner = this.centralContentService.getContentByBody(
      'banner_funds_capital_gains_losses',
      content,
    )
    this.fundsCapitalBanner2 = this.centralContentService.getContentByBody(
      'banner_funds_capital_gains_losses_2',
      content,
    )
    this.realizedUnrealizedGains = this.centralContentService.getContentByBody(
      'fund_definitions_realized_and_unrealized_gains_losses_understand_the_tax_implications',
      content,
    )
    this.realizedGainsAndLosses = this.centralContentService.getContentByBody(
      'fund_definitions_realized_gains_and_losses',
      content,
    )
    this.unRealizedGainsAndLosses = this.centralContentService.getContentByBody(
      'fund_definitions_unrealized_gains_losses',
      content,
    )
    this.payableDateDefinition = this.centralContentService.getContentByBody(
      'fund_definitions_payable_date',
      content,
    )
    this.recordDateDefinition = this.centralContentService.getContentByBody(
      'fund_definitions_record_date',
      content,
    )
    this.exDividendDateDefinition = this.centralContentService.getContentByBody(
      'fund_definitions_ex_dividend_date',
      content,
    )
    this.reInvestDateDefinition = this.centralContentService.getContentByBody(
      'fund_definitions_reinvest_date',
      content,
    )
    this.distributionYieldDefinition =
      this.centralContentService.getContentByBody(
        'fund_definitions_distribution_yield',
        content,
      )
  }

  addItem() {
    /* istanbul ignore next */
    this.items = this.distributionsModel?.distributions.divCapGain?.item
      ? this.distributionsModel.distributions.divCapGain.item
      : []
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    this.noDistributionTableData = this.items.length === 0 ? true : false
  }

  /*eslint complexity: [2, 10]*/
  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date
    } else if (
      this.fromDate &&
      !this.toDate &&
      date &&
      date.after(this.fromDate)
    ) {
      this.toDate = date
    } else {
      this.toDate = null
      this.fromDate = date
    }
    if (this.fromDate && this.toDate) {
      this.fromDateFilter = `${this.fromDate.year}-
        ${this.beautifyDayMonth(String(this.fromDate.month))}-
        ${this.beautifyDayMonth(String(this.fromDate.day))}`
      this.toDateFilter = `${this.toDate.year}-
        ${this.beautifyDayMonth(String(this.toDate.month))}-
        ${this.beautifyDayMonth(String(this.toDate.day))}`
      const fromDateComp = new Date(this.fromDateFilter)
      fromDateComp.setHours(fromDateComp.getHours() + this.timeConvertUTC)
      const toDateComp = new Date(this.toDateFilter)
      toDateComp.setHours(toDateComp.getHours() + this.timeConvertUTC)
      this.isInDateRange(fromDateComp, toDateComp)
    }
  }

  addElement(element) {
    this.currentItems.push(element)
    return this.currentItems
  }

  isInDateRange(date1: Date, date2: Date) {
    this.currentItems = []
    let recordDate: Date
    this.items.forEach((element) => {
      recordDate = new Date(
        element?.['recordDate']
          ? element['recordDate']
          : '2011-07-30T00:00:00-04:00',
      )
      this.currentItems =
        date1 <= recordDate && recordDate <= date2
          ? this.addElement(element)
          : this.currentItems
    })
    this.setPageNumber()
  }

  beautifyDayMonth(date: string) {
    if (date.length === 1) {
      date = '0' + date
    }
    return date
  }

  isHovered(date: NgbDate) {
    return (
      this.fromDate &&
      !this.toDate &&
      this.hoveredDate &&
      date.after(this.fromDate) &&
      date.before(this.hoveredDate)
    )
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate)
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    )
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input)
    return parsed && this.calendar.isValid(NgbDate.from(parsed))
      ? NgbDate.from(parsed)
      : currentValue
  }

  getPageId(newState: DropdownState) {
    this.page = parseInt(newState.activeItems[0])
  }

  /*eslint max-statements: ["error", 20]*/
  setPageNumber() {
    const pages: number = Math.ceil(this.currentItems.length / this.maxPageSize)
    let results: string
    let resStart = 1
    let restEnd: number = this.maxPageSize
    this.pageNumberList = []

    if (this.currentItems.length === 0) {
      results = `0-${this.currentItems.length}`
      this.pageNumberList.push(
        `${results} of ${this.currentItems.length}       Page 1`,
      )
    } else if (this.currentItems.length < this.maxPageSize + 1) {
      results = `${resStart}-${this.currentItems.length}`
      this.pageNumberList.push(
        `${results} of ${this.currentItems.length}       Page 1`,
      )
    } else {
      for (let i = 1; i < pages + 1; i++) {
        if (i === pages) {
          results = `${resStart}-${this.currentItems.length}`
        } else {
          results = `${resStart}-${restEnd}`
        }
        this.pageNumberList.push(
          `${results} of ${this.currentItems.length}       Page ${i}`,
        )
        resStart = resStart + this.maxPageSize
        restEnd = restEnd + this.maxPageSize
      }
    }
    this.menuData = {
      groups: [
        {
          items: this.pageNumberList
            ? this.pageNumberList.map((pageNumber, index) => {
                return {
                  labelText: `${pageNumber}`,
                  id: `${index + 1}`,
                }
              })
            : [],
        },
      ],
    }
    this.placeholderText = this.menuData?.groups[0]?.items[0]?.labelText
  }

  handleSelectionChange(newState: DropdownState) {
    // Update the page and announce the change
    this.getPageId(newState)
    this.announcePageChange()
  }
  findScreenSize() {
    this.innerWidth = window.innerWidth
  }

  announcePageChange() {
    if (this.pageNumberList.length > 1) {
      this.distributionAriaLiveRegion.nativeElement.innerText = `Dividend Income and Capital Gains table updated above`

      if (this.distributionAriaLiveRegion.nativeElement.innerText !== '') {
        setTimeout(() => {
          this.distributionAriaLiveRegion.nativeElement.innerText = ''
          // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        }, 1000)
      }
    }
  }

  calltableScrollEvent() {
    setTimeout(() => {
      this.tableContainer = document.querySelector('.horizontal-scroll-table')
      if (this.tableContainer != null) {
        this.tableContainer.addEventListener('scroll', () => {
          this.scrollTableHandler()
        })
      }
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    }, 300)
  }

  scrollTableHandler() {
    this.showRightButton =
      this.tableContainer.offsetWidth + this.tableContainer.scrollLeft >
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      this.tableContainer.scrollWidth - 1
        ? false
        : true
    this.scrollBarPosition = this.tableContainer.scrollLeft
  }

  moveRight() {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    this.tableContainer.scrollLeft += 150
  }

  moveLeft() {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    this.tableContainer.scrollLeft -= 150
  }

  ngOnDestroy(): void {
    this.distributionsSubscription.unsubscribe()
  }
}
